import Navbar from './components/Navbar';
import Hero from './components/Hero';
import EngineeringApproach from './components/EngineeringApproach';
import AboutExpertise from './components/AboutExpertise';
import CoreValues from './components/CoreValues';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <EngineeringApproach />
      <AboutExpertise />
      <CoreValues />
      <ContactFooter />
    </main>
  );
}